import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import Register from '../views/Register.vue'
import AnnouncementsList from '../views/AnnouncementsList.vue'
import AnnouncementDetail from '../views/AnnouncementDetail.vue'
import AnnouncementCreate from '../views/AnnouncementCreate.vue'
import AnnouncementEdit from '@/views/AnnouncementEdit.vue'
import NewsList from '../views/NewsList.vue' // Placeholder
import NewsDetail from '../views/NewsDetail.vue' // Placeholder
import EducationsList from '../views/EducationsList.vue' // Placeholder
import EducationDetail from '../views/EducationDetail.vue' // Placeholder
import Profile from '../views/Profile.vue' // Placeholder
import Favorites from '../views/Favorites.vue' // Placeholder
import Messages from '../views/Messages.vue' // Placeholder
import Notifications from '../views/Notifications.vue' // Placeholder
import AuthCallback from '../views/AuthCallback.vue' // Google OAuth callback
import VerificationResult from '../views/VerificationResult.vue';
import ForgotPassword from '../views/ForgotPassword.vue';
import ResetPassword from '../views/ResetPassword.vue';
import store from '../store' // Vuex store'u import et

const routes = [
  { path: '/', name: 'Home', component: Home },
  { path: '/login', name: 'Login', component: Login, meta: { requiresUnauth: true } }, // Sadece giriş yapmamışlar
  { path: '/register', name: 'Register', component: Register, meta: { requiresUnauth: true } },
  { path: '/googleauth/callback', name: 'AuthCallback', component: AuthCallback }, // Google yönlendirmesi için
  { path: '/announcements', name: 'AnnouncementsList', component: AnnouncementsList },
  { path: '/announcements/new', name: 'AnnouncementCreate', component: AnnouncementCreate, meta: { requiresAuth: true } }, // Sadece giriş yapmışlar
  { path: '/announcements/:id', name: 'AnnouncementDetail', component: AnnouncementDetail, props: true }, // ID'yi prop olarak gönder
  {
    path: '/announcements/:id/edit', // Düzenleme için yol
    name: 'AnnouncementEdit',        // Rota adı
    component: AnnouncementEdit,     // Yeni component
    props: true,                     // :id parametresini prop olarak gönder
    meta: { requiresAuth: true }     // Giriş yapmayı gerektirir
  },
  { path: '/news', name: 'NewsList', component: NewsList }, // Placeholder
  { path: '/news/:id', name: 'NewsDetail', component: NewsDetail, props: true }, // Placeholder
  { path: '/educations', name: 'EducationsList', component: EducationsList }, // Placeholder
  { path: '/educations/:id', name: 'EducationDetail', component: EducationDetail, props: true }, // Placeholder
  { path: '/profile', name: 'Profile', component: Profile, meta: { requiresAuth: true } }, // Placeholder
  { path: '/favorites', name: 'Favorites', component: Favorites, meta: { requiresAuth: true } }, // Placeholder
  { path: '/messages', name: 'Messages', component: Messages, meta: { requiresAuth: true } }, // Placeholder
  { path: '/notifications', name: 'Notifications', component: Notifications, meta: { requiresAuth: true } }, // Placeholder
  {
    path: '/verification-result', // Route for backend redirect
    name: 'VerificationResult',
    component: VerificationResult,
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword,
    meta: { requiresUnauth: true } // Only accessible when logged out
  },
  {
    path: '/reset-password', // Token will be in query string: /reset-password?token=...
    name: 'ResetPassword',
    component: ResetPassword,
    meta: { requiresUnauth: true } // Only accessible when logged out
  },
  // Yakalanamayan rotalar için 404 sayfası eklenebilir
  // { path: '/:pathMatch(.*)*', name: 'NotFound', component: () => import('../views/NotFound.vue') }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Rota Koruyucusu (Navigation Guard)
router.beforeEach((to, from, next) => {
  const isAuthenticated = store.getters['auth/isAuthenticated']; // Vuex'ten auth durumunu al

  if (to.meta.requiresAuth && !isAuthenticated) {
    // Giriş gerektiren sayfa ve kullanıcı giriş yapmamışsa Login'e yönlendir
    next({ name: 'Login', query: { redirect: to.fullPath } }); // Nereye gitmek istediğini query'de tut
  } else if (to.meta.requiresUnauth && isAuthenticated) {
    // Sadece giriş yapmamışların girebileceği sayfa ve kullanıcı giriş yapmışsa Ana Sayfa'ya yönlendir
    next({ name: 'Home' });
  } else {
    // Diğer durumlarda normal devam et
    next();
  }
});


export default router